import React, { useState, useCallback, useRef, useEffect } from 'react';

import { ButtonProps } from './types';
import { useNewUiTheme } from '../newUiTheme';

export function Button(props: ButtonProps) {
  const uiTheme = useNewUiTheme();

  const [loading, setLoading] = useState(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const onClick = useCallback(async () => {
    if (loading) {
      return;
    }

    if (props.onClick) {
      setLoading(true);

      try {
        await props.onClick();
        setLoading(false);
      } finally {
        if (mounted.current) {
          setLoading(false);
        }
      }
    }
  }, [loading, props.onClick]);

  return (
    <uiTheme.buttons.DefaultButtonLayout
      {...props}
      onClick={onClick}
      isLoading={props.isLoading ?? loading}
      loadingText={props.loadingText}
      style={props.style}
    />
  );
}
